import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import NoDataFound from '../../../assets/images/no-data-found.png';
import NoDataSVG from '../../../assets/dynamic-colors/No-DataSVG';
import { useAppBranding } from '../../../config/branding';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import CustomToggleButton from '../../../shared-components/custom-toggle-button/CustomToggleButton';
import stationManagement from '../../../utils/api/station-management';

interface Device {
  _id: string;
  chargingPointSn: string;
  chargingPointName: string;
  isDeviceOffline: boolean;
  connectorType: string;
  connectors: { connectorId: number; status: string }[];
}

const tabMenus = ['all', 'online', 'offline'];

/**
 * Devices
 * @returns
 */
function Devices() {
  const dispatch = useAppDispatch();
  const { images: brandImage } = useAppBranding();
  const { selectedChargingPoint } = useAppSelector((state) => state.stationManagement);
  const [openTab, setOpenTab] = useState<number>(0);
  const [devicesData, setDevicesData] = useState<Device[]>([]);
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation('sidePanel');
  /**
   * Handle the tab change function
   * @param number
   */
  const changeTabPages = (number: number) => {
    setOpenTab(number);
  };
  /**
   * device list api call
   */
  const handleDeviceList = async () => {
    setLoading(true);
    if (!selectedChargingPoint?.id) return;
    try {
      const response = await stationManagement.fetchDeviceList({
        chargingStation: selectedChargingPoint?.id,
      });
      setDevicesData(response.data || []);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      dispatch({
        type: 'notification/setNotificationDetails',
        payload: {
          type: 'error',
          notificationDetails: {
            statusCode: error?.response?.data?.code || 200,
            message: error?.response?.data?.message || t('errorMessage'),
          },
        },
      });
    }
  };

  const filteredDevices =
    openTab === 0
      ? devicesData
      : devicesData.filter((device) => {
        if (openTab === 1) return !device.isDeviceOffline; // Online
        if (openTab === 2) return device.isDeviceOffline; // Offline
        return false; // Maintenance (no field in data for now)
      });

  const statusClassMap: Record<string, string> = {
    online: 'online',
    offline: 'offline',
  };
  const showImages = filteredDevices.length <= 4;

  useEffect(() => {
    handleDeviceList();
  }, [selectedChargingPoint]);
  return (
    <div className="all-devices-container" dir={i18n.dir()}>
      <div className="devices-heading">
        <div className="table-tab">
          <CustomToggleButton
            defaultActiveIndex={openTab}
            onToggle={changeTabPages}
            labels={tabMenus.map((menu) => t(menu))}
          />
        </div>
      </div>
      <div className="devices-content">
        <div className="online-offline">
          <p>{t('devices')}</p>
          <p>{t('statusDevices', { status: t(tabMenus[openTab]) })}</p>
        </div>

        <div>
          {(() => {
            let deviceslist = null;
            if (loading) {
              deviceslist = (
                <div className="skeleton-grid-loader">
                  {[...Array(10)].map((index) => (
                    <div className="skeleton-card" key={index} />
                  ))}
                </div>
              );
            } else if (filteredDevices.length > 0) {
              deviceslist = (
                <div className={`device-grid ${showImages ? 'images-show' : ''}`}>
                  {' '}
                  {filteredDevices.map((device) => (
                    <div className="device-card" key={device._id}>
                      <div
                        className={`device-status ${statusClassMap[device.isDeviceOffline ? 'offline' : 'online']
                          }`}>
                        <div className="status-dot" />
                        <div className="status-name">
                          {device.isDeviceOffline ? t('offline') : t('online')}
                        </div>
                      </div>

                      {showImages && (
                        <div className="empty-charger-image">
                          <img
                            src={brandImage.emptyChargerImage}
                            alt={t('emptyCharger')}
                            className="device-details-image"
                          />
                          <div
                            className={`device-status-container ${statusClassMap[device.isDeviceOffline ? 'offline' : 'online']
                              }`}>
                            <div className="static-container" />
                            <div className="animation-container" />
                          </div>
                        </div>
                      )}

                      <div className="device-info">
                        <div className="tooltip-container name">
                          <p className="device-name">{device.chargingPointName}</p>
                          <span className="tooltip-text">{device.chargingPointName}</span>
                        </div>
                        <div className="tooltip-container device-id">
                          <p className="device-name">{device.chargingPointSn}</p>
                          <span className="tooltip-text">{device.chargingPointSn}</span>
                        </div>
                      </div>

                      <div className="device-footer">
                        <div className="device-ccs">{device.connectorType}</div>
                        <div className="device-version">{device.connectors.length}</div>
                      </div>
                    </div>
                  ))}
                </div>
              );
            } else if (filteredDevices.length === 0) {
              deviceslist = (
                <div className="table-no-data-wrap">
                  {/* <img src={NoDataFound} alt="" className="no-data-found-image" /> */}
                  <div className="no-data-svg-wrapper">
                    <NoDataSVG primaryColor="var(--primary-color)"/>
                  </div>
                  <div className="no-data-found-details">
                    <h3>{t('noDataTitle')}</h3>
                    <p>{t('noDataDescription')}</p>
                  </div>
                </div>
              );
            }

            return deviceslist;
          })()}
        </div>
      </div>
    </div>
  );
}

export default Devices;
